export default __webpack_public_path__ + "static/media/signout.29776ffe.svg";